import * as React from 'react';
import Footer from '../../components/footer/Footer';

import '../../assets/style.css';
import { thematix } from '../../data/thematix';
import Section from '../../components/section/Section';
import Navbar from '../../components/nav/Navbar';

import {isBrowser, isMobile } from 'react-device-detect';

export default function Thematic(){
    return (
        <>
        <Navbar/>
        
        <div className="background-opaque flex-column" style={{height:"100%", position:"relative"}}>
            <div className="flex-column centered" style={{paddingTop:"40vh", minHeight:"100vh", alignItems:"center"}}>
                <h1 className='pillbox-huge button-huge hpd-green-background pillbox-like' style={{fontWeight:"400", fontSize:isMobile?"2rem":"3rem", marginBottom:"2rem", width:"80%", textAlign:"center"}}>Tematska <span className="font-italic" >područja</span></h1>
                <div style={{width:isMobile?"95%":"80%", position:"relative"}}>
                {
                    thematix.map(({title, subtitle, content, bullets}, index)=>{
                      return <Section key={index} style={{marginBottom:"3rem"}} className={"section-opaque section-overlay-transparent " + (index%2==0?"section-half-pillbox-top":"section-half-pillbox-bottom")} 
                                            title={<div style={{width:"100%", textAlign:"right"}}><h2 className="pillbox-huge button-huge button-color-trans-dark pillbox-like" style={{fontSize:isMobile?"1.5rem":"3rem", fontWeight:"400"}}>{title}</h2></div>}  content={
                        <div><h2 style={{fontSize:isMobile?"1rem":"2rem",fontWeight:"400", marginTop:"0"}}><span>{subtitle}</span></h2>
                        <div style={{padding:isMobile?"0 1rem 1rem 1rem":"0 6rem 6rem 6rem"}}>
                            {
                                bullets!=""?
                                <div>
                                {Object.keys(bullets).map((key, index)=>{
                                    return <div style={{fontSize:isMobile?"1rem":"1.5rem", textAlign:"left"}} key={index} className="flex-row">
                                        <p style={{padding:isMobile?"5px":"20px", fontSize:isMobile?"1.2rem":"1.7rem"}}>{key})</p><p style={{padding:"20px"}}>{bullets[key]}</p>
                                    </div>
                                })}</div>:<></>
                                
                      }
                            <p style={{fontSize:isMobile?"1rem":"1.5rem", whiteSpace:"pre-line", lineHeight:"1.5", textAlign:"left"}}>
                                {content}
                            </p>

                        </div>
                        </div>
                      }/>  
                    })
                }
            
            </div>
            </div>
        
        </div>
        <Footer/>
        </>

    )
}